import * as React from 'react'
import { withStyles } from '@material-ui/core/styles';
import MuiToolbar from '@material-ui/core/Toolbar';

export const styles = (theme: {
  palette?: { common: { white: any }; secondary: { main: any } };
  spacing?: { unit: number };
  breakpoints?: any;
}) => ({
  root: {
    height: 64,
    [theme.breakpoints.up("sm")]: {
      height: 70
    }
  }
});

function Toolbar(props: any) {
  return <MuiToolbar {...props} />;
}

export default withStyles(styles)(Toolbar);


// WEBPACK FOOTER //
// ./src/components/header/Toolbar.tsx